/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const requestCvUpdateRequestSchema = z
  .object({
    sendEmail: z.boolean().optional(),
  })
  .nullable();
